import { IcoX, IcoTriangle } from "./icons";

// ─── Skip Review & Select All Confirmation Modal ───────────────────────────
// Mirrors the "Skip Review & Select All" caution dialog in
// BulkUploadSearchResults.jsx — applies globally across EPH + Vendor, not
// scoped to whichever sub-tab is active.

export default function SkipReviewModal({ onClose, onConfirm }) {
  return (
    <div className="rc-mover" onClick={onClose}>
      <div className="rc-mdl sm" onClick={(e) => e.stopPropagation()}>
        <div className="rc-mdl-hdr neut">
          <div className="rc-mdl-hl">
            <div className="rc-mdl-ico">
              <IcoTriangle size={15} cls="ic-p" />
            </div>
            <p className="rc-mdl-htit">Caution</p>
          </div>
          <button className="rc-mdl-close" onClick={onClose}>
            <IcoX size={15} />
          </button>
        </div>
        <div className="rc-mdl-body plain">
          <div className="rc-skip-warn">
            All records across the EPH and Vendor tabs will be selected for
            DCR creation and Consents submission without your review, using
            the supplied information in the uploaded file. This may result in
            duplicate Profiles. Are you sure you want to continue?
          </div>
        </div>
        <div className="rc-mdl-foot">
          <button className="btn btn-o" style={{ flex: 1 }} onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-r" style={{ flex: 1 }} onClick={onConfirm}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}
